import { render, staticRenderFns } from "./PackagesViewContent.vue?vue&type=template&id=14e9f24a&lang=pug"
import script from "./PackagesViewContent.vue?vue&type=script&lang=js"
export * from "./PackagesViewContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports